export default "__VITE_ASSET__DIdXUent__"